export function canShowUnlockButton(credits, isUnlocked, required = 480) {
  return !isUnlocked && Number.isFinite(credits) && credits >= required;
}
